module.exports = __webpack_public_path__ + "img/facebook-ads.f36f79ac.png";